<template>
  <div class="row">
    <b-col cols="12">
      <b-card body-class="pb-0">
        <div class="row">
          <div class="col-9">
            <h5>مدیریت ویدئو ها</h5>
          </div>
          <div class="col-3">
            <Rinput placeholder="جستجو ..." v-model="search" @keyup.native="searchinput" />
          </div>
        </div>
      </b-card>
    </b-col>
    <b-col
      md="4"
      sm="2"
      lg="4"
      v-for="(item, index) in videos"
      v-bind:key="index"
    >
 
    <video-item :item="item" />
  
    </b-col>
    <b-col cols="12" class="text-center my-8">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="meta.total"
        :page-size="15"
        :page-count="meta.per_page"
        :current-page="meta.current_page"
        @current-change="changepage"
      >
      </el-pagination>
    </b-col>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
  name: "videomaneger",
  data() {
    return {
      videos: [],
      links: [],
      meta: [],
      search: "",
      show: false,
      page: 0
    };
  },
  created() {
    this.getall();
  },
  computed: {
    baseurl() {
      return ApiService.baseurl;
    }
  },
  methods: {
    getall: function() {
      ApiService.get("admin/video#", {})
        .then(({ data }) => {
          this.videos = data.data;
          this.links = data.links;
          this.meta = data.meta;
        })
        .catch(({ response }) => {});
    },
    changepage: function(page) {
      let thisv = this;
      this.page = page;
      ApiService.get("admin/video?page=" + page + "#", {})
        .then(response => {
          thisv.videos = response.data.data;
          thisv.meta = response.data.meta;
          thisv.links = response.data.links;
        })
        .catch(({ responsea }) => {});
    },

    searchinput: function(event) {
      let search = this.search;
      if (this.search.length > 2) {
        let thisv = this;
        ApiService.post("admin/video/search", {
          search
        })
          .then(response => {
            thisv.videos = response.data.data;
            thisv.meta = response.data.meta;
            thisv.links = response.data.links;
          })
          .catch(({ responsea }) => {});
      } else if (this.search.length == 0) {
        this.changepage(this.page);
      }
    }
  }
};
</script>
